import { render, staticRenderFns } from "./NewLossReason.vue?vue&type=template&id=5af1427c&scoped=true"
import script from "./NewLossReason.vue?vue&type=script&lang=js"
export * from "./NewLossReason.vue?vue&type=script&lang=js"
import style0 from "./NewLossReason.vue?vue&type=style&index=0&id=5af1427c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af1427c",
  null
  
)

export default component.exports